import { useCallback, useEffect } from "react";
import { any, remove, where } from "../utils/collection";
import { isNullOrWhitespace } from "../utils";

export type EventNotificationHandler = (args?:any) => void;

interface IEventNotificationRegistration {
    eventName: string;
    handler: EventNotificationHandler;
    subscriptionId: string;
}

class EventNotificationServiceClass {
    constructor() {
        this.registrations = [];
    }

    public subscribe(eventName:string, subscriptionId:string, handler:EventNotificationHandler, thisObj?:any): void {
        // no event name, subscription ID, or handler given is a no-no, but won't throw an error (at this time)
        if(!eventName || isNullOrWhitespace(subscriptionId) || !handler) { return; }
        // don't subscribe more than once
        if(any(this.registrations, r => r.subscriptionId === subscriptionId && r.eventName === eventName)) { return; }

        //bind handler if necessary
        if(!!thisObj) {
            handler = handler.bind(thisObj);
        }

        //create registration
        this.registrations.push({
            eventName,
            handler,
            subscriptionId
        });
    }

    public unsubscribe(eventName:string, subscriptionId:string) {
        this.registrations = remove(this.registrations, r => r.subscriptionId === subscriptionId && r.eventName === eventName);
    }

    public dispatch(eventName:string, args?:any):void {
        // event name required
        if(!eventName) { return; }

        // obtain and fire handlers for event
        where(this.registrations, r => r.eventName === eventName)
                .map(h => h.handler(args));
    }

    private registrations:IEventNotificationRegistration[];
}

export const EventNotificationService = new EventNotificationServiceClass();

export function useEventNotification(eventHandler: (args?: any) => void, deps: React.DependencyList, event: string, subscriber: string) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handler = useCallback(eventHandler, deps);

    useEffect(() => {
        EventNotificationService.subscribe(event, subscriber, handler);
    
        return () => {
          EventNotificationService.unsubscribe(event, subscriber);
        };
      }, [subscriber, event, handler]);
}